import { Component, Inject, OnInit, Optional } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA,MatDialogActions} from '@angular/material/dialog';
import { HotToastRef } from '@ngneat/hot-toast';
import { GroupSharingComponent } from '../group-sharing.component';
import { GroupSharingService } from '../group-sharing.service.component';

@Component({
  selector: 'app-common-popup',
  templateUrl: './common-dialog.component.html',
  styleUrls: ['./common-dialog.component.scss']
})
export class CommonDialogComponent implements OnInit {
  constructor( @Optional() @Inject(HotToastRef) public toastRef: HotToastRef<any>) { }

  ngOnInit(): void {
    
  }

  closeDialog(res){
   // this.dialogRef.close(res)
   this.toastRef.close({dismissedByAction: true})
  }

  closeDialog1(res){
    // this.dialogRef.close(res)
    this.toastRef.close({dismissedByAction: false})
   }
}
